define('presentation/settings/callQueues/validators/addCallQueueViewModelValidator',[
    'presentation/common/routeToModal/common/routeToValidationHelper',
    'presentation/common/validation/validationRule',
    'presentation/common/validation/commonValidator'
], function() {
    return function() {
        const self = this;

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const RouteToValidationHelperConstructor = require('presentation/common/routeToModal/common/routeToValidationHelper');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        const _validationHelper = new RouteToValidationHelperConstructor();

        let _commonValidator = null;
        let _viewModel;

        self.registerViewModel = (viewModel) => {
            _commonValidator = new CommonValidatorConstructor(viewModel);
            _viewModel = viewModel;

            let validationRules = new ValidationRulesConstructor();
            validationRules.field("name")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addCallQueue:nameRequired')
                .addValidationI18n(_validateNameUnique, 'addCallQueue:nameNotUnique');
            validationRules.field('isQueueFullRoutingRuleValid')
                .addValidationI18n(_isQueueFullRoutingRuleValid, 'addCallQueue:routingRuleError');

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        const _isQueueFullRoutingRuleValid = () => _validationHelper.validateRouteToViewModel(_viewModel.queueFullRoutingRuleViewModel());

        // Compared against the queues the page loaded rather than commonState, which does not track
        // call queues.
        const _validateNameUnique = (callQueueName) => {
            const trimmedName = callQueueName.trim().toLowerCase();

            return _viewModel.existingCallQueueNames().every((existingCallQueue) => {
                return existingCallQueue.name.trim().toLowerCase() !== trimmedName ||
                    existingCallQueue.accountCallQueueId === _viewModel.accountCallQueueId;
            });
        };

        self.validate = () => {
            return _commonValidator.validate();
        };

        self.resetValidation = () => {
            _viewModel.name.resetValidation();
        };
    };
});

